/**
 * Turn a "watchable" URL the admin pastes (YouTube watch link, Vimeo page,
 * direct mp4, etc.) into an embed-friendly URL the storefront lightbox can
 * load inside an <iframe> / <video> tag.
 *
 * Falls back to the original URL when no specific pattern matches.
 */
export function extractEmbedUrl(url) {
    if (!url) return "";
    // YouTube — watch / youtu.be / shorts → embed
    const yt = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{6,})/,
    );
    if (yt) {
        return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0`;
    }
    // Vimeo — vimeo.com/12345 → player.vimeo.com/video/12345
    const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) {
        return `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
    }
    return url;
}

/** Best-effort thumbnail URL for a given video URL (YouTube only). */
export function deriveVideoThumbnail(url) {
    if (!url) return "";
    const yt = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{6,})/,
    );
    if (yt) {
        return `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg`;
    }
    return "";
}
